import { Box, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { SectionHeading } from "./SectionHeading";
import { FeatureCard } from "./FeatureCard";
import { FadeInOnView } from "./FadeInOnView";
import { aboutAsset } from "../aboutAssets";

const feature1 = aboutAsset("building-card1.png");
const feature2 = aboutAsset("building-card2.png");
const feature3 = aboutAsset("building-card3.png");
const feature4 = aboutAsset("building-card4.png");
const halftone1 = aboutAsset("halftone-1.webp");
const halftone2 = aboutAsset("halftone-2.webp");
const halftone3 = aboutAsset("halftone-3.webp");
const halftone4 = aboutAsset("halftone-4.webp");

const features = [
  {
    imageSrc: feature1,
    description: "300,000+ comics from top\npublishers and creators",
  },
  {
    imageSrc: feature2,
    description:
      "A subscription service built for\ndiscovering and binge reading",
  },
  {
    imageSrc: feature3,
    description: "A marketplace for buying new\nand premium titles",
  },
  {
    imageSrc: feature4,
    description: "A growing hub for fans, creators,\nand communities",
  },
];

export function WhatWereBuildingSection() {
  return (
    <Box maxW="960px" mx="auto" px="24px" pt="80px" pb="40px">
      <SectionHeading title="What we're building" />

      <Text
        mt="40px"
        fontSize="24px"
        fontWeight="400"
        color="dune.700"
        textAlign="center"
        lineHeight="1.4"
        maxW="600px"
        mx="auto"
      >
        GlobalComix brings comics, manga, and their communities into one place.
      </Text>

      <Box position="relative" mt="60px">
        {/* Halftone background decorations (56:56) — one behind each card */}
        <Image
          src={halftone1}
          alt=""
          position="absolute"
          top="-150px"
          left="-220px"
          w="450px"
          h="450px"
          opacity={0.4}
          pointerEvents="none"
          display={{ base: "none", md: "block" }}
        />
        <Image
          src={halftone2}
          alt=""
          position="absolute"
          top="-120px"
          right="-200px"
          w="450px"
          h="450px"
          opacity={0.4}
          pointerEvents="none"
          display={{ base: "none", md: "block" }}
        />
        <Image
          src={halftone3}
          alt=""
          position="absolute"
          bottom="-20px"
          left="-180px"
          w="450px"
          h="450px"
          opacity={0.4}
          pointerEvents="none"
          display={{ base: "none", md: "block" }}
        />
        <Image
          src={halftone4}
          alt=""
          position="absolute"
          bottom="20px"
          right="130px"
          w="460px"
          h="460px"
          opacity={0.4}
          pointerEvents="none"
          display={{ base: "none", md: "block" }}
        />

        <SimpleGrid
          columns={{ base: 1, md: 2 }}
          spacing="40px"
          position="relative"
          zIndex={1}
        >
          {features.map((feature, index) => (
            <FadeInOnView
              key={feature.description}
              delay={index * 140}
            >
              <FeatureCard
                imageSrc={feature.imageSrc}
                description={feature.description}
              />
            </FadeInOnView>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}
